import { actionCreatorFactory } from "typescript-fsa";
import { GeoPayload } from "./types";

const createAction = actionCreatorFactory("USER");

export const updateGeoAccess = createAction<GeoPayload>("UPDATE_GEO_ACCESS", (geoPayload: GeoPayload) => {
  return geoPayload;
});
